var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCalenderGrey(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20.143,
    height: 20.559,
    viewBox: "0 0 20.143 20.559",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_3310",
    "data-name": "Group 3310",
    transform: "translate(-13916.563 -3522.953)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2676",
    "data-name": "Path 2676",
    d: "M105.565,97.341h15.2a2.474,2.474,0,0,0,2.471-2.471V81.327a2.474,2.474,0,0,0-2.471-2.471h-.012v1.18a1.543,1.543,0,0,1-1.541,1.541h-.182a1.543,1.543,0,0,1-1.541-1.541V78.856h-8.649v1.18a1.543,1.543,0,0,1-1.541,1.541h-.182a1.543,1.543,0,0,1-1.541-1.541v-1.18h-.012a2.474,2.474,0,0,0-2.471,2.471V94.869a2.474,2.474,0,0,0,2.471,2.471Zm-1.052-13.035h17.3V94.869a1.053,1.053,0,0,1-1.052,1.052h-15.2a1.053,1.053,0,0,1-1.052-1.052Z",
    transform: "translate(13813.469 3446.172)",
    fill: "#999"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2677",
    "data-name": "Path 2677",
    d: "M178.59,245.88h2.963v2.37H178.59Z",
    transform: "translate(13741.052 3285.961)",
    fill: "#999"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2678",
    "data-name": "Path 2678",
    d: "M268.66,245.88h2.963v2.37H268.66Z",
    transform: "translate(13654.657 3285.961)",
    fill: "#999"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2679",
    "data-name": "Path 2679",
    d: "M358.71,245.88h2.963v2.37H358.71Z",
    transform: "translate(13568.279 3285.961)",
    fill: "#999"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2680",
    "data-name": "Path 2680",
    d: "M448.77,245.88h2.963v2.37H448.77Z",
    transform: "translate(13481.894 3285.961)",
    fill: "#999"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2681",
    "data-name": "Path 2681",
    d: "M178.59,321.41h2.963v2.37H178.59Z",
    transform: "translate(13741.052 3213.512)",
    fill: "#999"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2682",
    "data-name": "Path 2682",
    d: "M268.66,321.41h2.963v2.37H268.66Z",
    transform: "translate(13654.657 3213.512)",
    fill: "#999"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2683",
    "data-name": "Path 2683",
    d: "M358.71,321.41h2.963v2.37H358.71Z",
    transform: "translate(13568.279 3213.512)",
    fill: "#999"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2684",
    "data-name": "Path 2684",
    d: "M448.77,321.41h2.963v2.37H448.77Z",
    transform: "translate(13481.894 3213.512)",
    fill: "#999"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2685",
    "data-name": "Path 2685",
    d: "M178.59,396.95h2.963v2.37H178.59Z",
    transform: "translate(13741.052 3141.053)",
    fill: "#999"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2686",
    "data-name": "Path 2686",
    d: "M268.66,396.95h2.963v2.37H268.66Z",
    transform: "translate(13654.657 3141.053)",
    fill: "#999"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2687",
    "data-name": "Path 2687",
    d: "M358.71,396.95h2.963v2.37H358.71Z",
    transform: "translate(13568.279 3141.053)",
    fill: "#999"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2688",
    "data-name": "Path 2688",
    d: "M448.77,396.95h2.963v2.37H448.77Z",
    transform: "translate(13481.894 3141.053)",
    fill: "#999"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2689",
    "data-name": "Path 2689",
    d: "M181.074,32.137h.182a.88.88,0,0,0,.879-.879V28.882a.88.88,0,0,0-.879-.879h-.182a.88.88,0,0,0-.879.879v2.375a.88.88,0,0,0,.879.879Z",
    transform: "translate(13739.513 3494.95)",
    fill: "#999"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2690",
    "data-name": "Path 2690",
    d: "M473.114,32.137h.182a.88.88,0,0,0,.879-.879V28.882A.88.88,0,0,0,473.3,28h-.182a.88.88,0,0,0-.879.879v2.375a.88.88,0,0,0,.879.879Z",
    transform: "translate(13459.386 3494.95)",
    fill: "#999"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalenderGrey);
export default __webpack_public_path__ + "static/media/calenderGrey.f603590fadbe0b0dace54dd8635004cb.svg";
export { ForwardRef as ReactComponent };